import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";


export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);
}
